'use strict';

module.exports = require('./dist/client');



//////////////////
// WEBPACK FOOTER
// ./~/nes/client.js
// module id = uUYA
// module chunks = 0